import axios from "axios";
import { riparaStruttura, riparaTesto } from "@/lib/text";
import { printHtmlDirect } from "@/lib/directPrint";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: `${API}/gestionale/magazzino`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (window.location.pathname.startsWith("/gestionale/magazzino-alluminio")) {
    config.headers["X-Magazzino-Tipo"] = "alluminio";
  }
  return config;
});

api.interceptors.response.use((response) => {
  if (response.config?.responseType !== "blob" && response.config?.responseType !== "arraybuffer") {
    response.data = riparaStruttura(response.data);
  }
  return response;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Errore inatteso. Riprova.";
  if (typeof detail === "string") return riparaTesto(detail);
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatCurrency(v) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);
}

export function formatNumber(v, digits = 0) {
  return new Intl.NumberFormat("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v || 0);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  } catch { return iso; }
}

export function downloadCSV(filename, rows) {
  if (!rows || !rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    if (v == null) return "";
    const s = String(v).replace(/"/g, '""');
    return /[",\n;]/.test(s) ? `"${s}"` : s;
  };
  const csv = [headers.join(";"), ...rows.map(r => headers.map(h => escape(r[h])).join(";"))].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  a.click(); URL.revokeObjectURL(url);
}

export function downloadPDF(title, columns, rows) {
  const style = `<style>
    body { font-family: 'IBM Plex Sans', system-ui, sans-serif; padding: 24px; color: #0f172a; }
    h1 { font-family: 'Cabinet Grotesk', sans-serif; letter-spacing: -.02em; font-size: 22px; margin: 0 0 4px;}
    p.meta { color: #64748b; font-size: 12px; margin: 0 0 16px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th, td { text-align: left; padding: 6px 8px; border-bottom: 1px solid #e2e8f0; }
    th { background: #f1f5f9; text-transform: uppercase; font-size: 10px; letter-spacing: .05em; }
    tr:nth-child(even) td { background: #f8fafc; }
  </style>`;
  const now = new Date().toLocaleString("it-IT");
  const head = `<tr>${columns.map(c => `<th>${c.label}</th>`).join("")}</tr>`;
  const body = rows.map(r => `<tr>${columns.map(c => `<td>${r[c.key] ?? ""}</td>`).join("")}</tr>`).join("");
  printHtmlDirect(`<html><head>${style}</head><body>
    <h1>${title}</h1><p class="meta">Generato il ${now}</p>
    <table><thead>${head}</thead><tbody>${body}</tbody></table>
  </body></html>`, title);
}

